import {RootState} from '../../testutils/configureStore'
import {priceWatchApi} from '../services'
import {PriceWatchPayload} from '../types'

export interface GetPriceWatchKeyParams {
  checkIn: string
  checkOut: string
  rooms: string
  hotelId: string
  currency: string
}

const getPriceWatchKey = (params: GetPriceWatchKeyParams): string =>
  `${params.checkIn}#${params.checkOut}#${params.rooms}#${params.hotelId}#${params.currency}`

const NO_TRACKINGS: PriceWatchPayload[] = []

const selectTrackings = (state: RootState, userId?: string) =>
  userId
    ? (priceWatchApi.endpoints.getUserPriceWatchTrackings.select({userId})(
        state
      ).data ?? NO_TRACKINGS)
    : NO_TRACKINGS

export const selectPriceWatchEntry = (
  params: GetPriceWatchKeyParams & {userId?: string}
) => {
  const key = getPriceWatchKey(params)

  return (state: RootState) =>
    selectTrackings(state, params.userId).find(
      entry => getPriceWatchKey(entry) === key
    )
}

export const selectPendingEnable = (state: RootState) =>
  state.priceWatch.pendingEnable

export const selectToast = (state: RootState) => state.priceWatch.toast

export const selectPriceTrendsTrackingContext = (state: RootState) =>
  state.priceWatch.priceTrendsTrackingContext

export const selectPendingEnableTrackingContext = (state: RootState) =>
  state.priceWatch.pendingEnable?.trackingContext
